import React, { useEffect, useState, useRef, useMemo, useLayoutEffect } from "react";
import Style from './radio.module.scss'

function Radio({ questionId, getRadioData, options, setOptions, setScrollBottom, latestLifeLine, result, setResult, nextClickHandler, fiftyFiftyUsed, audiencePoll }) {
    const [checkData, setCheckData] = useState(getRadioData)
    const [select, setSelect] = useState(0)
    const [block, setBlock] = useState(true)
    const [hasLongOption, setHasLongOption] = useState(false)

    const optionRefs = useRef([]);

    function choseChangeHandler(event) {
        if (block) {
            const value = event.currentTarget.getAttribute('data-value');
            setOptions(value)
            setSelect(1)
            setScrollBottom(true)

            nextClickHandler({
                selectedOption: value,
                question: getRadioData
            });
        }
        setBlock(false)
    }

    // ✅ Single check per checkData change
    useLayoutEffect(() => {
        if (!checkData?.length) {
            // debugger
            setHasLongOption(false);
            return;
        }

        let cancelled = false;

        const checkWrappedText = () => {
            if (cancelled) return;

            const validRefs = optionRefs.current.filter(ref => ref);

            if (validRefs.length === 0) {
                setTimeout(checkWrappedText, 50);
                return;
            }
            const anyWrapped = validRefs.some((ref) => {

                const pTag = ref.querySelector('p');
                if (!pTag) return false;
                return pTag.scrollHeight > 20;
            });
            if (!cancelled) {
                setHasLongOption(anyWrapped);
            }
        };
        
        const timer = setTimeout(checkWrappedText, 300);

        return () => {
            cancelled = true;
            clearTimeout(timer);
        };
    }, [checkData]);

    useEffect(() => {
        if (!getRadioData) return;

        optionRefs.current = [];

        let displayOptions = checkData?.length > 0 && latestLifeLine?.toString() !== "68f0f8f6d2910ad6f1475439"
            ? [...checkData]
            : [...getRadioData];

        if (fiftyFiftyUsed && latestLifeLine.toString() == "68f0f8dfd2910ad6f1475434") {
            const incorrectOptions = displayOptions.filter(opt => !opt.correct);
            const shuffled = incorrectOptions.sort(() => 0.5 - Math.random());
            const disabledIncorrect = shuffled.slice(0, 2).map(opt => opt._id);

            displayOptions = displayOptions.map(opt => ({
                ...opt,
                disabled: disabledIncorrect.includes(opt._id)
            }));
        }

        if (audiencePoll && latestLifeLine.toString() == "68f0f825d2910ad6f1475417") {
            const activeOptions = displayOptions.filter(opt => !opt.disabled);
            const allPercentages = [];
            let totalUsed = 0;

            activeOptions.forEach(() => {
                const randomPercent = Math.floor(Math.random() * 16) + 10;
                allPercentages.push(randomPercent);
                totalUsed += randomPercent;
            });

            const correctIdx = activeOptions.findIndex(opt => opt.correct);
            const remaining = 100 - totalUsed;
            allPercentages[correctIdx] += remaining;

            const maxIncorrect = Math.max(...allPercentages.filter((_, idx) => idx !== correctIdx));
            if (allPercentages[correctIdx] <= maxIncorrect) {
                const maxIncorrectIdx = allPercentages.findIndex((p, idx) => p === maxIncorrect && idx !== correctIdx);
                const steal = Math.floor(Math.random() * 6) + 5;
                allPercentages[maxIncorrectIdx] -= steal;
                allPercentages[correctIdx] += steal;
            }

            let activeIdx = 0;
            displayOptions = displayOptions.map(opt => { 
                if (opt.disabled) {
                    return opt;
                } else {
                    const percentage = allPercentages[activeIdx++];
                    return {
                        ...opt,
                        percentage,
                        color: opt.correct ? "green" : "red"
                    };
                }
            });
        }

        setCheckData(displayOptions);
        setSelect(0);
        setBlock(true);
    }, [getRadioData, fiftyFiftyUsed, audiencePoll, latestLifeLine]);

    return (
        <div className={`${Style.input_radio} ${hasLongOption ? Style.full_width : ''}`}>
            {checkData?.map((item, index) => (
                <div className={Style.radioCover} key={item._id|| index}>
                    {audiencePoll && <p className={Style.textoption1}>{item.percentage}% Vote</p>}
                                        <div
                        ref={el => {
                            if (el) {
                                optionRefs.current[index] = el;
                            }
                        }}
                        className={Style.input_radio_item}
                        id={item.option}
                        data-value={item._id}
                        onClick={item.disabled ? undefined : choseChangeHandler}
                        style={{
                            background:audiencePoll && item?.percentage !== undefined
                                ? `linear-gradient(
                                    to right, 
                                    ${item.correct ? "#21CF60" : "#FA5743"} ${item.percentage}%, 
                                    rgba(0,0,0,0.17) ${item.percentage}%
                                  )`
                                :  result === 2 && options === item._id
                                ? "#21CF60"
                                : result === 3 && options === item._id
                                    ? "#FA5743"
                                    : "rgba(142, 84, 233, 0.17)",
                            marginTop: "10px",
                            opacity: item.disabled ? 0.48 : 1,
                            color: "#fff",
                            padding: "10px 20px",
                            borderRadius: "14px",
                            minHeight: "41px",
                            position: "relative"
                        }}

                    >
                        <p className={Style.textoption}>{item.option}</p>
                    </div>
                </div>
            ))}
        </div>
    )
}

export default Radio;